import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';


import { MainModule } from './main/main.module';
import { PdfViewerComponent } from './shared/pdf-viewer/pdf-viewer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OldAboutComponent } from './shared/old-about/old-about.component';
import { CertificateComponent } from './users/certificate/certificate.component';
import { SignupTemplateComponent } from './shared/signup-template/signup-template.component';
import { ForgotPasswordTemplateComponent } from './shared/forgot-password-template/forgot-password-template.component';
import { PaymentReceivedTemplateComponent } from './shared/payment-received-template/payment-received-template.component';
import { AuthInterceptor } from './auth.interceptor';
import { AnnouncementDesignerComponent } from './admin/announcement-designer/announcement-designer.component';
import { SubscriptionManagementComponent } from './admin/subscription-management/subscription-management.component';
import { PricingComponent } from './subscription/pricing/pricing.component';
import { SampleCourseListComponent } from './courses/sample-course-list/sample-course-list.component';
import { SampleCoursePlayComponent } from './courses/sample-course-play/sample-course-play.component';

@NgModule({
  declarations: [
    AppComponent,
    PdfViewerComponent,
    OldAboutComponent,
    CertificateComponent,
    SignupTemplateComponent,
    ForgotPasswordTemplateComponent,
    PaymentReceivedTemplateComponent,
    AnnouncementDesignerComponent,
    SubscriptionManagementComponent,
    PricingComponent,
    SampleCourseListComponent,
    SampleCoursePlayComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MainModule,
    NgxExtendedPdfViewerModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
